import script from "./OrganizationTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationTeam.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationTeam.vue?vue&type=style&index=0&id=f6736b3c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6736b3c"]])

export default __exports__